import { store } from '../store/configureStore'

import { selectCursorNodeId } from '../store/cursor'
import { selectParentId } from '../controllers/treeEngine'

export const initAutoScroll = () => {
    store.subscribe(onStoreChange)
    scrollAfterOpeningList()
}

const onStoreChange = () => {
    // scrollIfTitleNodeChanged()
}

let titleNodeId
export const scrollIfTitleNodeChanged = () => {
    const previousValue = titleNodeId
    const state = store.getState()
    const cursorNodeId = selectCursorNodeId(state)
    if (!cursorNodeId) {
        return
    }
    titleNodeId = selectParentId(cursorNodeId)
    if (previousValue !== titleNodeId) {
        scrollAfterOpeningList()
    }
}

// These functions are basically the same, but for some reason trying to optimize then in a more modular form hurted the performance noticeably

export const scrollAfterOpeningList = () => {
    const cursorElement = document.getElementsByClassName('cursor-node')[0]
    if (!cursorElement) {
        return
    }

    let scrollPosition = window.pageYOffset

    const nodeBounds = cursorElement.getBoundingClientRect()
    const titleBounds = document.getElementById('titleview').getBoundingClientRect()
    const top = nodeBounds.top - titleBounds.bottom
    const bottom = nodeBounds.bottom - titleBounds.bottom
    const viewHeight = window.innerHeight - titleBounds.height

    // if cursorElement is too low, scroll down
    if (bottom > viewHeight * 0.2) {
        scrollPosition += bottom - viewHeight * 0.2
    }

    // if cursorElement is too high in the pageview, scroll up
    if (top < viewHeight * 0.2) {
        scrollPosition -= viewHeight * 0.2 - top
    }

    window.scroll(0, scrollPosition)
}

export const scrollAfterArrowKey = () => {
    const cursorElement = document.getElementsByClassName('cursor-node')[0]
    if (!cursorElement) {
        return
    }

    let scrollPosition = window.pageYOffset

    const nodeBounds = cursorElement.getBoundingClientRect()
    const titleBounds = document.getElementById('titleview').getBoundingClientRect()
    const top = nodeBounds.top - titleBounds.bottom
    const bottom = nodeBounds.bottom - titleBounds.bottom
    const viewHeight = window.innerHeight - titleBounds.height

    // if cursorElement is too high in the pageview, scroll up
    if (top < viewHeight * 0.2) {
        scrollPosition -= viewHeight * 0.2 - top
    }

    // if cursorElement is too low, scroll down
    if (bottom > viewHeight * 0.8) {
        scrollPosition += bottom - viewHeight * 0.8
    }

    window.scroll(0, scrollPosition)
}
